import { Component } from '@angular/core';
import { LoadingIndicatorBase } from '@zero/shared/charts/ui-charts-base';

@Component({
  selector: 'charts-web-loading-indicator',
  templateUrl: './loading-indicator-web.component.html',
  standalone: true,
})
export class LoadingIndicatorWebComponent extends LoadingIndicatorBase {}
